<script type="ts">
  export let scoresAndRewards: {
    challengeScores:    string[],
    competitionScores:  string[],
    stakingRewards:     string[],
    challengeRewards:   string[],
    competitionRewards: string[],
    overallRewards:     string[]
  };
</script>

<div class="flex flex-col">
  <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
      <div class="shadow overflow-hidden border-b border-gray-200 rounded-md">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="pl-6 pr-4 py-3 text-right text-xs font-medium text-gray-500 tracking-wider">
                #
              </th>
              <th scope="col" class="px-4 py-3 text-right text-xs font-medium text-gray-500 tracking-wider">
                Staked
              </th>
<!--              <th scope="col" class="px-4 py-3 text-right text-xs font-medium text-gray-500 tracking-wider">-->
<!--                Competition Score-->
<!--              </th>-->
<!--              <th scope="col" class="px-4 py-3 text-right text-xs font-medium text-gray-500 tracking-wider">-->
<!--                Staking Reward-->
<!--              </th>-->
              <th scope="col" class="px-4 py-3 text-right text-xs font-medium text-gray-500 tracking-wider">
                Awarded
              </th>
              <th scope="col" class="px-4 py-3 text-right text-xs font-medium text-gray-500 tracking-wider">
                Burned
              </th>

              <th scope="col" class="px-4 py-3 text-right text-xs font-medium text-gray-500 tracking-wider">
                Relative Gain (%)
              </th>
<!--              <th scope="col" class="pl-4 pr-6  py-3 text-right text-xs font-medium text-gray-500 tracking-wider">-->
<!--                Overall Reward-->
<!--              </th>-->

              <!-- <th scope="col" class="relative px-6 py-3">
                <span class="sr-only">Edit</span>
              </th> -->
            </tr>
          </thead>
          <tbody>
            <!-- Odd row -->
            {#each scoresAndRewards.challengeScores.reverse() as challengeScore, i}
              <tr class="bg-white tabular-nums text-right" class:bg-gray-50={i % 2}>
                <td class="pl-6 pr-4 py-4 whitespace-nowrap text-xs font-medium text-gray-900">
                  {scoresAndRewards.challengeScores.length - i}
                </td>
                <td class="px-4 py-4 whitespace-nowrap text-xs text-gray-500">
                  {parseFloat(challengeScore).toFixed(2)}
                </td>
<!--                <td class="px-4 py-4 whitespace-nowrap text-xs text-gray-500">-->
<!--                  {parseFloat(scoresAndRewards.competitionScores[scoresAndRewards.challengeScores.length - i - 1]).toFixed(4)}-->
<!--                </td>-->
<!--                <td class="px-4 py-4 whitespace-nowrap text-xs text-gray-500">-->
<!--                  {parseFloat(scoresAndRewards.stakingRewards[scoresAndRewards.challengeScores.length - i - 1]).toFixed(2)}-->
<!--                </td>-->
                <td class="px-4 py-4 whitespace-nowrap text-xs text-gray-500">
                  {parseFloat(scoresAndRewards.challengeRewards[scoresAndRewards.challengeScores.length - i - 1]).toFixed(2)}
                </td>
                <td class="px-4 py-4 whitespace-nowrap text-xs text-gray-500">
                  {parseFloat(scoresAndRewards.burnedAmount[scoresAndRewards.challengeScores.length - i - 1]).toFixed(2)}
                </td>

                <td class="px-4 py-4 whitespace-nowrap text-xs text-gray-500">
                  {
                          parseFloat(
                                  100 *
                                  (
                            scoresAndRewards.challengeRewards[scoresAndRewards.challengeScores.length - i - 1]
                           - scoresAndRewards.burnedAmount[scoresAndRewards.challengeScores.length - i - 1]
                                  )
                                  / challengeScore

                          ).toFixed(2)
                  }
                </td>
<!--                <td class="pl-4 pr-6 whitespace-nowrap text-xs text-gray-500">-->
<!--                  {parseFloat(scoresAndRewards.overallRewards[scoresAndRewards.challengeScores.length - i - 1]).toFixed(2)}-->
<!--                </td>-->
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
